import Link from 'next/link';
import { ComponentProps } from 'react';

type LinkWrapperProps = Omit<ComponentProps<typeof Link>, 'href'> & {
  children: React.ReactNode;
  href?: string | null;
};

export default function LinkWrapper({ children, href, ...props }: LinkWrapperProps) {
  if (!href) {
    if (props.className) return <div className={props.className}>{children}</div>;
    return children;
  }
  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
}
